function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("path", {
  id: "SVGID_1_",
  d: "M361.1,35.2l84.3,84.3c4.1,4.1,4.1,10.8,0,14.9l-84.3,84.3c-6.6,6.6-18,1.9-18-7.4l0-63.3H10.1 c-5.8,0-10.5-4.7-10.5-10.5v-21c0-5.8,4.7-10.5,10.5-10.5h333.1l0-63.3C343.1,33.3,354.5,28.6,361.1,35.2z M274.1,246.8 L36.9,309.6v34.7l237.2,50.9V246.8z M115.4,400.9c-0.3,1.8-1,3.5-1,5.3c0,20.6,16.8,28.2,37.4,28.2c16.7,0,30.6-1.8,35.5-16.8 L115.4,400.9z M299,185.9c6.9,0,12.5,5.6,12.5,12.5v248.4c0,6.9-5.6,12.5-12.5,12.5h-12.5c-6.9,0-12.5-5.6-12.5-12.5v-10.1 L223.6,426c-8.6,31.7-37.3,45.8-71.8,45.8c-41.3,0-74.8-24.2-74.8-65.6c0-4.8,0.9-9.3,1.8-13.8l-42.4-9.9c-1.3,5.5-6,9.7-11.9,9.7 H12c-6.9,0-12.5-5.6-12.5-12.5V274.2c0-6.9,5.6-12.5,12.5-12.5h12.5c5.9,0,10.6,4.2,11.9,9.7l237.7-62.9v-10.1 c0-6.9,5.6-12.5,12.5-12.5H299z"
}));

var SvgArrowMegaphone = function SvgArrowMegaphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 448 512",
    style: {
      enableBackground: "new 0 0 448 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", null, _ref2, React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }), React.createElement("clipPath", {
    id: "SVGID_2_"
  }, React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgArrowMegaphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/arrow-megaphone.f984cb8e.svg";
export { ForwardRef as ReactComponent };